import { IObservation } from "./observation.model";
import { ITagHistorical } from "./tag-historical.model";

interface Record {
	Asset: any;
	AssetId: number;
	EffectiveAlarmCategoryId: number;
	EffectiveAlarmCategoryName?: string;
	EffectiveSeverityLevelId?: number;
	Favorite: boolean;
	Guid: string;
	Historical?: Array<any>;
	Id: number;
	IsAlarm: boolean;
	IsAlert: boolean;
	IsCritical: boolean;
	IsInformational: boolean;
	IsWarning: boolean;
	JBTStandardObservation?: any;
	JBTStandardObservationId?: number;
	Name: string;
	Severity?: string;
	ShortTagName?: string;
	SimpleName?: string;
	SiteId?: number;
	SiteName?: string;
	TagNamePrefix?: string;
	UpdateCount: number;
	ValueWhenActive?: any;
	ValueTranslation?: string;
	IsDiagnostic: boolean;
    LastObs: IObservation;
  }
  

export class ITag implements Record {
	Asset: any;
	AssetId!: number;
	EffectiveAlarmCategoryId: number;
	EffectiveAlarmCategoryName?: string;
	EffectiveSeverityLevelId?: number;
	Favorite: boolean = false;
	Guid!: string;
	Historical?: Array<ITagHistorical>;
	Id!: number;
	IsAlarm: boolean = false;
	IsAlert: boolean = false;
	IsCritical: boolean = false;
	IsInformational: boolean = false;
	IsWarning: boolean = false;
	JBTStandardObservation?: any;
	JBTStandardObservationId?: number;
	Name!: string;
	Severity?: string;
	ShortTagName?: string;
	SimpleName?: string;
	SiteId?: number;
	SiteName?: string;
	TagNamePrefix!: string;
	UpdateCount: number;
	ValueWhenActive?: any;
	ValueTranslation!: string;
	IsDiagnostic: boolean = false;
    LastObs: IObservation;

	constructor(
			Asset: any,
			AssetId: number,
			Favorite: boolean = false,
			Guid: string,
			Id: number,
			IsAlarm: boolean = false,
			IsAlert: boolean = false,
			IsCritical: boolean = false,
			IsInformational: boolean = false,
			IsWarning: boolean = false,
			Name: string,
			TagNamePrefix: string,
			ValueTranslation: string,
			UpdateCount: number,
            LastObs: IObservation,
			EffectiveAlarmCategoryId: number,
			EffectiveAlarmCategoryName?: string,
			JBTStandardObservation?: any,
			JBTStandardObservationId?: number,
			EffectiveSeverityLevelId?: number,
			Severity?: string,
			ShortTagName?: string,
			SimpleName?: string,
			SiteId?: number,
			SiteName?: string,
			ValueWhenActive?: any,
			IsDiagnostic: boolean = false,
            Historical?: Array<ITagHistorical>,
			
	  ) {
		this.Asset = Asset;
		this.AssetId = AssetId;
		this.Favorite = Favorite,
		this.Guid = Guid,
		this.Id = Id,
		this.IsAlarm = IsAlarm,
		this.IsAlert = IsAlert,
		this.IsCritical = IsCritical, 
		this.IsInformational = IsInformational,
		this.IsWarning = IsWarning,
		this.Name = Name,
        this.TagNamePrefix = TagNamePrefix,
		this.ValueTranslation = ValueTranslation,
		this.LastObs = LastObs,
        this.JBTStandardObservation = JBTStandardObservation,
		this.JBTStandardObservationId = JBTStandardObservationId,
        this.EffectiveAlarmCategoryId = EffectiveAlarmCategoryId,
        this.EffectiveAlarmCategoryName = EffectiveAlarmCategoryName,
        this.EffectiveSeverityLevelId = EffectiveSeverityLevelId,
		this.Severity = Severity,
		this.ShortTagName = ShortTagName,
		this.SimpleName = SimpleName,
		this.SiteId = SiteId,
		this.SiteName = SiteName,
		this.UpdateCount = UpdateCount,
		this.ValueWhenActive = ValueWhenActive,
		this.IsDiagnostic = IsDiagnostic,
        this.Historical = Historical
	}

}
